const menuList = [
  {
    id: 89,
    value: 0,
    backgroundColor: '#6590ff',
    img: require('@/assets/image/default/invWare/account.png'),
    text: '库房档案',
    path: '/Account/sys/wareHouseDefineVue/indexVue.html',
    isHidden: true
  },
  {
    id: 112,
    idList: [112, 301],
    value: 0,
    backgroundColor: '#ff9c65',
    img: require('@/assets/image/default/invWare/inventory.png'),
    text: '库房盘点',
    path: '/templates/vue-account/dist/index.htm#/inventory?invCheckWay=C',
    isHidden: true
  },
  {
    id: 9,
    idList: [9, 325],
    value: 1,
    backgroundColor: '#66d6ff',
    img: require('@/assets/image/default/invWare/examine.png'),
    text: '库房调拨',
    path: '/Account/sys/InvMoveVue/indexVue.html',
    isHidden: true
  },
  {
    id: 12,
    value: 0,
    backgroundColor: '#7e65ff',
    img: require('@/assets/image/default/invWare/allocation.png'),
    text: '组拆装',
    path: '/templates/vue-account/dist/index.htm#/invMakeSearch',
    isHidden: true
  },
  {
    id: 15,
    value: 0,
    backgroundColor: '#65ebff',
    img: require('@/assets/image/default/invWare/turnover.png'),
    text: '库房主账查询',
    path: '/templates/vue-account/dist/index.htm#/inventoryQuery',
    isHidden: true
  },
  {
    id: 17,
    value: 0,
    backgroundColor: '#ff7567',
    img: require('@/assets/image/default/invWare/profitandloss.png'),
    text: '库存流水查询',
    path: '/templates/vue-account/dist/index.htm#/inventoryQuery?tag=D',
    isHidden: true
  },
  {
    id: 18,
    value: 0,
    backgroundColor: '#ff67af',
    img: require('@/assets/image/default/invWare/change.png'),
    text: '库房变动查询',
    path: '/templates/vue-account/dist/index.htm#/inventoryQuery?tag=C',
    isHidden: true
  },
  // {
  //   id: 18,
  //   value: 0,
  //   backgroundColor: '#ffdd65',
  //   img: require('@/assets/image/default/invWare/history.png'),
  //   text: '历史库存查询',
  //   path: '/Account/sys/InvItemDay/index.html',
  //   isHidden: true
  // }
]

export const getMenuList = (flag) => {
  if (flag) {
    let indexOf112 = menuList.findIndex(i => i.id == 112)
    if (indexOf112 > -1) {
      menuList[indexOf112].id = '302'
      menuList[indexOf112].text = '整库盘点'
      menuList[indexOf112].path = '/templates/vue-account/dist/index.htm#/invCheckPart'
    }
    let indexOf12 = menuList.findIndex(i => i.id == 12)
    if (indexOf12 > -1) {
      menuList[indexOf12].id = 184
      menuList[indexOf12].text = '商品组合'
      menuList[indexOf12].path = '/templates/vue-account/dist/index.htm#/invMakeQuery'
    }
    let indexOf9 = menuList.findIndex(i => i.id == 9)
    if (indexOf9 > -1) {
      menuList[indexOf9].text = '调拨录单'
    }
    let indexOf15 = menuList.findIndex(i => i.id == 15)
    if (indexOf15 > -1) {
      menuList[indexOf15].text = '库房主账'
    }
    let indexOf17 = menuList.findIndex(i => i.id == 17)
    if (indexOf17 > -1) {
      menuList[indexOf17].text = '库存流水'
    }
    let indexOfSub15 = menuList.findIndex(i => i.text == '库房变动查询')
    if (indexOfSub15 > -1) {
      menuList[indexOfSub15].text = '库存变动'
    }
    return menuList
  }
  return menuList
}